import { useQuery } from '@tanstack/react-query';

import { useErrorMessage } from '#error-message/useErrorMessage';

import { MeetingKey } from './keys';
import { MeetingService } from './meetingService';

export function useGetMeeting(id?: number, enabled = true) {
  const getMettingQuery = useQuery({
    queryKey: [MeetingKey.MEETINGS, id],
    queryFn: () => MeetingService.getMeeting(id).then((response) => response.data),
    enabled: enabled && !!id,
  });

  const errorMessage = useErrorMessage(getMettingQuery.error);
  return { ...getMettingQuery, errorMessage };
}
